import React from 'react'
import './Button.css'

type ButtonProps = {
  type?: string
  size?: string
  width?: string
  onClick?: (e: any) => void
  style?: React.CSSProperties
  data?: string
  id?: string
  loading?: boolean
  children: React.ReactNode
}

const Button: React.FC<ButtonProps> = (props) => {
  let type = props.type || 'primary'
  let size = props.size || 'regular'
  let width = props.width || 'width-regular'
  return (
    <button
      onClick={props.onClick}
      className={`cocunat-Button ${type} ${size} ${width}`}
      style={props.style}
      data-button-id={props.data}
      id={props.id}
    >
      {props.loading ? (
        <img
          src='https://global.cocunat.com/icons/loading.gif'
          height='20'
          width='20'
          alt='Loading'
        />
      ) : (
        <div>{props.children}</div>
      )}
    </button>
  )
}

export default Button
